import { combineReducers } from '@reduxjs/toolkit';

import auth from 'app/auth/store';
import logsSlice from 'app/main/logs/store/logsSlice';
import verifications from 'app/main/verifications/store';
import { LOGS_MODULE_KEY } from 'app/main/logs/constants';
import amlScanSlice from 'app/main/aml/store/amlScanSlice';
import { AML_SCAN_MODULE_KEY } from 'app/main/aml/constants';
import users, { USERS_MODULE_KEY } from 'app/main/teams/store/usersSlice';
import invites, { INVITES_MODULE_KEY } from 'app/main/teams/store/invitesSlice';
import flow, { FLOW_MODULE_KEY } from 'app/main/workflow-builder/store/flowSlice';
import universalLinks, { UNIVERSAL_LINKS_KEY } from 'app/main/universal-links/store/universalLinkSlice';
import statisticsDashboard, {
  STATISTICS_DASHBOARD_KEY,
} from 'app/main/dashboard/statistics/store/statisticsSlice';
import applications, { APPLICATIONS_MODULE_KEY } from 'app/main/applications/store/applicationsSlice';
import roleManagement, { ROLE_MANAGEMENT_MODULE_KEY } from 'app/main/teams/store/roleManagementSlice';
import clientDetails, { CLIENT_DETAILS_MODULE_KEY } from 'app/main/client-details/store/clientDetailsSlice';
import questionnaire, { QUESTIONNAIRES_MODULE_KEY } from 'app/main/questionnaire/store/questionnaireSlice';
import transactionMonitoringSlice, {
  TRANSACTION_MONITORING_MODULE_KEY,
} from 'app/main/transaction-monitoring/store/transactionMonitoringSlice';

import fuse from './fuse';
import i18n from './i18nSlice';
import mode from './modeSlice';
import socket from './socketSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    [USERS_MODULE_KEY]: users,
    [INVITES_MODULE_KEY]: invites,
    [CLIENT_DETAILS_MODULE_KEY]: clientDetails,
    [STATISTICS_DASHBOARD_KEY]: statisticsDashboard,
    [APPLICATIONS_MODULE_KEY]: applications,
    [FLOW_MODULE_KEY]: flow,
    [UNIVERSAL_LINKS_KEY]: universalLinks,
    [QUESTIONNAIRES_MODULE_KEY]: questionnaire,
    [ROLE_MANAGEMENT_MODULE_KEY]: roleManagement,
    [AML_SCAN_MODULE_KEY]: amlScanSlice,
    [LOGS_MODULE_KEY]: logsSlice,
    [TRANSACTION_MONITORING_MODULE_KEY]: transactionMonitoringSlice,
    ...verifications,
    auth,
    fuse,
    i18n,
    mode,
    socket,
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === 'user/userLoggedOut') {
    // state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
